import { render, staticRenderFns } from "./SubscribeToTextApp.vue?vue&type=template&id=5dde8314"
import script from "./SubscribeToTextApp.vue?vue&type=script&lang=js"
export * from "./SubscribeToTextApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports